$(document).ready(function () {
    $.ajax({
      type: 'GET',
      url:  window.routes.cart_url + '?view=minquant',
      async: false,
      success: function (itemData) {
        let arr = itemData
          .trim()
          .split(',#')
          .filter(function (v) {
            return v !== '';
          });
        var allow_checkout = 0;
        for (var i = 0; i < arr.length; i++) {
          let arr1 = arr[i].split('<--split-->');
          let prod_id = parseInt(arr1[0]);
          let prduct_quantity = parseInt(arr1[1]);
          let prduct_maxquantity = arr1[2];
          let prduct_key = arr1[3];
          let prduct_title = arr1[4];
          let prduct_variantid = parseInt(arr1[5]);
          let prduct_totalinv = parseInt(arr1[6]);
          let prduct_type = arr1[7];
          if (prduct_type != 'AppleCare') {
            if (prduct_maxquantity != '') {
              if (parseInt(prduct_totalinv) < parseInt(prduct_maxquantity)) {
                if (parseInt(prduct_quantity) > parseInt(prduct_totalinv)) {
                  $('#prod_error_' + prduct_variantid).html(
                    prduct_title + ' allow to purchase quantity ' + prduct_totalinv + '.'
                  );
                  allow_checkout = 1;
                }
              } else {
                var total_max_product = checkoutMaxquantity(prod_id);
                if (parseInt(total_max_product) > parseInt(prduct_maxquantity)) {
                  $('#prod_error_' + prduct_variantid).html(
                    prduct_title + ' allow to purchase quantity ' + prduct_maxquantity + '.'
                  );
                  allow_checkout = 1;
                }
              }
            } else {
              if (parseInt(prduct_quantity) > parseInt(prduct_totalinv)) {
                $('#prod_error_' + prduct_variantid).html(
                  prduct_title + ' allow to purchase quantity ' + prduct_totalinv + '.'
                );
                allow_checkout = 1;
              }
            }
          }
        }
      },
    });
    function checkoutMaxquantity(product_id) {
      var total_max_quantity = 0;
      var product_id = product_id;
      $.ajax({
        type: 'GET',
        dataType: 'json',
        async: false,
        url: window.routes.cart_url + '.js',
        success: function (cart) {
          for (var i = 0; i < cart.items.length; i++) {
            var product_cartid = cart.items[i].product_id;
            if (product_cartid == product_id) {
              total_max_quantity += cart.items[i].quantity;
            }
          }
        },
      });
      return total_max_quantity;
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return msie > 0 || trident > 0;
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function (event) {
      document.querySelector('#cart').submit();
    });
  });

  var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  setTimeout(function () {
    if (is_safari && $('.cart__dynamic-checkout-buttons ul li').length <= 0) {
      $('.cart__dynamic-checkout-buttons').hide();
    } 
  }, 1000);